exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mobileViewOverlay .SuggestionsList_suggestions__k_T1T{padding-top:5px;padding-bottom:10px;border-bottom:1px solid #e7e6e6}#mobileViewOverlay .SuggestionsList_suggestions__k_T1T .SuggestionsList_suggestions__list__2PFZ3 .SuggestionsList_suggestion__13tKB{display:list-item;padding:5px 15px;font-size:14px;color:#333}#GlobalSearchApp .SuggestionsList_suggestions__k_T1T{padding-top:5px;padding-bottom:10px;border-bottom:1px solid #e7e6e6}#GlobalSearchApp .SuggestionsList_suggestions__k_T1T .SuggestionsList_suggestions__list__2PFZ3 .SuggestionsList_suggestion__13tKB{display:list-item;padding:5px 15px;font-size:14px;color:#333}@media only screen and (min-width:961px){#GlobalSearchApp .SuggestionsList_suggestions__k_T1T .SuggestionsList_suggestions__list__2PFZ3 .SuggestionsList_suggestion__13tKB{padding:5px 10px;cursor:pointer}#GlobalSearchApp .SuggestionsList_suggestions__k_T1T .SuggestionsList_suggestions__list__2PFZ3 .SuggestionsList_suggestion__13tKB:hover{background-color:#f5f5f5;color:#42b4e6}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333333",
	"textGray": "#9b9b9b",
	"textWhite": "#ffffff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"suggestions": "SuggestionsList_suggestions__k_T1T",
	"suggestions__list": "SuggestionsList_suggestions__list__2PFZ3",
	"suggestion": "SuggestionsList_suggestion__13tKB"
};